import { Collapsible, FlexBox, Icon, Text } from '@dixa/lib-shared-habla';
import { useState } from 'react';

import { Shimmer } from '../../../../../shimmer/shimmer';

import styles from './mimSidekickReasoning.module.scss';

type MimSidekickReasoningProps = {
  text: string;
  state?: 'streaming' | 'done';
};

export const MimSidekickReasoning = ({
  text,
  state,
}: MimSidekickReasoningProps): JSX.Element => {
  const [isExpanded, setIsExpanded] = useState(false);
  const isStreaming = state === 'streaming';
  const label = isStreaming ? 'Thinking…' : 'Reasoning';

  return (
    <FlexBox flexDirection="column">
      <button
        type="button"
        className={styles.toggle}
        aria-expanded={isExpanded}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <Text.Paragraph as="span" variant="3" subdued>
          {isStreaming ? <Shimmer>{label}</Shimmer> : label}
        </Text.Paragraph>
        <Icon
          name={isExpanded ? 'angle-up' : 'angle-down'}
          size={16}
          color="secondary"
        />
      </button>
      <Collapsible isOpen={isExpanded} header={null}>
        <div className={styles.body}>
          <Text.Paragraph variant="4" subdued>
            {text}
          </Text.Paragraph>
        </div>
      </Collapsible>
    </FlexBox>
  );
};
